interface CategoryIconProps {
    categoryIconFilename: string | undefined;
}

const CategoryIcon = (props: CategoryIconProps) => (
    <img src={"/images/categories/" + (props.categoryIconFilename ?? "default.svg")} alt="Event category" style={{maxWidth: "45px", width: "40px", marginBottom: "0"}}/>
)

export default CategoryIcon;
